import { createGlobalStyle } from "styled-components";

import "./Font.css";

export const GlobalStylesApp = createGlobalStyle`
    * {
        margin: 0px;
        padding: 0px;
        text-decoration: none;
        font-family: Exo2 Light;
    }

    button, input {
        border: none;
        outline: none;
        background: transparent;
    }

    ul {
        list-style: none;
    }

    ol {
        list-style: decimal;
        margin-left: 20px;
    }

    @media (min-width: 1440px) {
        ol {
            font-size: 20px;
            line-height: 1.18;
        }
    }

    img {
        display: block;
    }

    body {
        background: ${({ theme }) => theme?.colors?.background};
        transition: background 350ms cubic-bezier(0.61, 0, 0.51, 1);
    }

    /* Custom scrollbar */

    /* width */
    &::-webkit-scrollbar {
        width: 15px;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: #1ac63f;
        transition: background 450ms cubic-bezier(0.61, 0, 0.51, 1);
    }
`;
